import {AppointmentFiltersModel} from '../models/appointment-filters.model';
import {TimeSlotQueryDto} from '../dtos/time-slot-query.dto';

export class AppointmentSelectionMapper {
  static toTimeSlotQueryDto(locationId: number, patientId: number | undefined, appointmentFiltersModel: AppointmentFiltersModel): TimeSlotQueryDto {
    return {
      locationIds: [locationId],
      patientId: patientId,
      categoryId: appointmentFiltersModel.categoryId!,
      employeeIds: appointmentFiltersModel.employeeId == 0 ? undefined : [appointmentFiltersModel.employeeId!],
    }
  }
}
